<template>
  <div class="mobile-floating-bar" @click="openRegisterModal">
    <div class="bar-top">
      <transition name="roll">
        <span class="open-text" :key="currentIndex">
          {{ messages[currentIndex] }}
        </span>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileFloatingBar',
  data() {
    return {
      currentIndex: 0,
      timer: null,
      messages: [
        '선착순 방문상담 접수중',
        '010-8329-xxxx님이 방문상담 신청하였습니다',
        '010-2547-xxxx님이 방문상담 신청하였습니다',
        '010-6814-xxxx님이 방문상담 신청하였습니다',
        '010-3705-xxxx님이 방문상담 신청하였습니다',
        '010-5126-xxxx님이 방문상담 신청하였습니다',
        '010-9248-xxxx님이 방문상담 신청하였습니다',
        '010-4673-xxxx님이 방문상담 신청하였습니다',
        '010-7915-xxxx님이 방문상담 신청하였습니다',
        '010-8462-xxxx님이 방문상담 신청하였습니다',
        '010-3581-xxxx님이 방문상담 신청하였습니다',
        '010-2976-xxxx님이 방문상담 신청하였습니다',
        '010-4821-xxxx님이 방문상담 신청하였습니다',
        '010-6395-xxxx님이 방문상담 신청하였습니다',
        '010-1742-xxxx님이 방문상담 신청하였습니다',
        '010-5068-xxxx님이 방문상담 신청하였습니다',
        '010-9137-xxxx님이 방문상담 신청하였습니다',
        '010-3254-xxxx님이 방문상담 신청하였습니다',
        '010-7806-xxxx님이 방문상담 신청하였습니다',
        '010-1589-xxxx님이 방문상담 신청하였습니다'
      ]
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.messages.length
    }, 2500)
  },
  beforeUnmount() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    openRegisterModal() {
      window.dispatchEvent(new CustomEvent('open-register-modal'))
    }
  }
}
</script>

<style scoped>
.mobile-floating-bar {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 900;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.bar-top {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 20px;
  padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));
  background: #f7efe8;
  overflow: hidden;
  min-height: 54px;
}

.open-text {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  padding: 0 20px;
  font-size: 15px;
  font-weight: 700;
  color: var(--main-color1);
  letter-spacing: -0.02em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 롤링 애니메이션 (세로) */
.roll-enter-active,
.roll-leave-active {
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.4s ease;
}

.roll-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.roll-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

@media (max-width: 768px) {
  .mobile-floating-bar {
    display: block;
  }
}
</style>
